import { compose, curry, path, reduce, keys } from "ramda"
import { isArray } from "../validate"

export const getRulesPaths = (fieldProps) => (fieldProps && isArray(fieldProps.fieldPath) ? ["fields", ...fieldProps.fieldPath] : ["fields"]) //if fieldProps = { fieldPath: ["nameEN"] } => ["fields", "nameEN"]

const filterSchemaByField = curry((validationSchema, fieldProps) => {
  const rulePath = getRulesPaths(fieldProps)
  const resolverDict = path(rulePath, validationSchema)
  const resolverRecords = compose(
    reduce((acc, key) => {
      acc.push({
        ruleKeyPath: [...rulePath, key],
        resolver: resolverDict[key]
      })
      return acc
    }, []),
    keys,
    path(rulePath)
  )(validationSchema)
  return resolverRecords
})

export default filterSchemaByField
